import styled from "styled-components/macro";
import { BoardsIcon } from "components/Icons/Boards";
import { GeoAlt } from "@styled-icons/bootstrap";
import {
  ExpandedDivider,
  FiltersButtonLabel,
  Root as GeoSearchFiltersRoot
} from "components/Map/GeoSearchFilters";
import { Root as RoomCardRoot } from "components/Room/RoomCard/styles";
import { MapRoot } from "../../components/Map/GeoMap";

export const RoomCardContainer = styled.div`
  position: absolute;
  right: 24px;
  bottom: 24px;
`;

export const GeoSearchFiltersContainer = styled.div`
  position: absolute;
  left: 24px;
  top: 24px;
  z-index: 1;
  width: 350px;
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  ${MapRoot} {
    flex-grow: 1;
  }
`;
export const SortButtonLabel = styled.span``;
export const MapViewSwitchContainer = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: center;
  transition: 0.5s;
  grid-column: 2/3;
  @media ${(props) => props.theme.media.leftmenu} {
    grid-column: 1/2;
  }
  & .rooms-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media ${(props) => props.theme.media.phone} {
    & .text-edit {
      display: none;
    }
    & .rooms-filter {
      padding: 8px;
    }

    gap: 0;
    margin-top: 24px;
  }
  & > div > div > h4 {
    font-size: 18px;
  }
`;

export const MapViewIcons = {
  List: styled(BoardsIcon)<{ selected: boolean }>`
    path {
      stroke: ${(props) =>
        props.selected
          ? props.theme.colors.textDimmed
          : props.theme.colors.softGray};
    }
  `,
  Map: styled(GeoAlt)<{ selected: boolean }>`
    path {
      fill: ${(props) =>
        props.selected
          ? props.theme.colors.textDimmed
          : props.theme.colors.softGray};
    }
  `
};

export const RoomsListContainer = styled.div`
  position: absolute;
  height: calc(100%);
  // width of two room cards with padding and gap
  width: ${248 * 2 + 11 + 15 + 16 * 2}px;
  box-sizing: border-box;

  left: 0;
  top: 0;
  background: white;
  z-index: 2;

  display: flex;
  flex-direction: column;

  ${GeoSearchFiltersRoot} {
    padding: 16px 16px 0 16px;
  }

  & > ${ExpandedDivider} {
    margin: 24px 16px;
  }
`;

export const Root = styled.div<{ $isMobileSwitcher: boolean }>`
  display: flex;
  height: 100%;

  @media (max-width: 1000px) {
    ${MapViewSwitchContainer} {
      top: auto;
      right: auto;
      bottom: 16px;
      left: 50%;
      z-index: 10;
      transform: translateX(-50%);

      .MapViewSwitcher {
        box-shadow: 0 1px 9px 1px #89898991;
      }
    }

    ${RoomsListContainer} {
      width: 100%;
    }

    ${RoomCardContainer} {
      bottom: 68px;
    }
  }

  @media ${({ theme }) => theme.media.tablet} {
    ${RoomCardContainer} {
      bottom: ${({ $isMobileSwitcher }) =>
        $isMobileSwitcher ? "68px" : "8px"};
    }
  }

  @media ${({ theme }) => theme.media.phone} {
    ${RoomCardContainer} {
      bottom: ${({ $isMobileSwitcher }) =>
        $isMobileSwitcher ? "68px" : "8px"};
      right: 50%;
      transform: translateX(50%);
    }
  }

  @media (max-width: 560px) {
    ${RoomsListContainer} {
      ${RoomCardRoot} {
        width: 100%;
      }

      ${FiltersButtonLabel} {
        display: none;
      }
      ${SortButtonLabel} {
        display: none;
      }
    }

    ${GeoSearchFiltersContainer} {
      position: static;
      width: 100%;
    }
  }
`;
